// @flow

import * as React from 'react';

import { compose } from 'redux';

import { withPageMeta } from '@gandi/app-runner';
import { needsAuth } from '@gandi/authentication';

import Presenter from './Presenter';

export default (compose(
  // TOFIX: add withTranslator for the withPageMeta?
  withPageMeta(args => ({
    title: args.__('Choose billing and ownership information - Gandi.net'),
  })),
  needsAuth,
)(Presenter): React.ComponentType<{}>);
